// src/pages/categorias/VerCategoria.js
import React, { useState, useEffect } from 'react'
import { Offcanvas, Badge } from 'react-bootstrap'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import { PanelFooter, PanelHeader } from 'components/Panel'
import { CATEGORIAS_NO_IMAGE } from 'config/categorias'
import { API_URL } from 'config/general'
import api from 'api/api'

function VerCategoria(props) {
	const { categoria, mostrar, cancelar, defaultImage } = props
	const [padreNombre, setPadreNombre] = useState('')
	const [atributos, setAtributos] = useState([])
	const [loadingAtributos, setLoadingAtributos] = useState(false)

	// Cargar imagen por defecto para pre-cargarla en el navegador
	useEffect(() => {
		const img = new Image()
		img.src = CATEGORIAS_NO_IMAGE
	}, [])

	// Cargar atributos de la categoría
	const cargarAtributos = async (categoriaId) => {
		try {
			setLoadingAtributos(true)
			const { datos } = await api.get(`a/jerarquias/${categoriaId}/atributos`)
			setAtributos(datos.atributos || [])
		} catch (error) {
			console.error('Error cargando atributos:', error)
			setAtributos([])
		} finally {
			setLoadingAtributos(false)
		}
	}

	useEffect(() => {
		if (categoria && categoria.jerarquiaPapa && categoria.jerarquiaPapa.nombre) {
			setPadreNombre(categoria.jerarquiaPapa.nombre)
		} else {
			setPadreNombre('Categoría principal')
		}

		// Cargar atributos cuando se muestra la categoría
		if (categoria && mostrar) {
			cargarAtributos(categoria.id)
		} else {
			setAtributos([])
		}
	}, [categoria, mostrar])

	const handleClose = () => {
		setAtributos([])
		cancelar()
	}

	// URL de la imagen
	const imageUrl = categoria && categoria.multimedia
		? `${API_URL}/${categoria.multimedia.url}`
		: CATEGORIAS_NO_IMAGE

	return (
		<Offcanvas show={mostrar} onHide={handleClose} placement="end">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Detalles de la categoría" />
			<Offcanvas.Body>
				{categoria && (
					<Row>
						<Col sm={12} md={6}>
							<h5 className="mb-3">Información de la categoría</h5>
							<Form className="ms-4">
								<Form.Group className="mb-3">
									<Form.Label>ID</Form.Label>
									<Form.Control
										type="text"
										value={categoria.id}
										disabled
									/>
								</Form.Group>
								<Form.Group className="mb-3">
									<Form.Label>Nombre</Form.Label>
									<Form.Control
										type="text"
										value={categoria.nombre}
										disabled
									/>
								</Form.Group>
								<Form.Group className="mb-3">
									<Form.Label>Categoría padre</Form.Label>
									<Form.Control
										type="text"
										value={padreNombre}
										disabled
									/>
								</Form.Group>

								{categoria.subcategorias && categoria.subcategorias.length > 0 && (
									<>
										<Form.Group className="mb-3">
											<Form.Label>Subcategorías ({categoria.subcategorias.length})</Form.Label>
											<ul className="list-group">
												{categoria.subcategorias.map(sub => (
													<li key={sub.id} className="list-group-item d-flex justify-content-between align-items-center">
														{sub.nombre}
														<span className="badge bg-secondary rounded-pill">Orden: {sub.orden}</span>
													</li>
												))}
											</ul>
										</Form.Group>
									</>
								)}
							</Form>

							{/* NUEVA SECCIÓN: Atributos asignados */}
							<div className="ms-4 mt-4">
								<h5 className="mb-3">
									<i className="fa fa-sliders me-2"></i>
									Atributos por defecto
								</h5>

								{loadingAtributos ? (
									<div className="text-center text-muted py-3">
										<i className="fa fa-spinner fa-spin me-2"></i>
										Cargando atributos...
									</div>
								) : atributos.length > 0 ? (
									<div className="atributos-lista">
										{atributos.map((tipo) => (
											<Card key={tipo.id} className="mb-2">
												<Card.Body className="py-2 px-3">
													<div className="d-flex justify-content-between align-items-center">
														<div>
															<strong>{tipo.nombre}</strong>
															{!tipo.activo && (
																<Badge bg="secondary" className="ms-2">Inactivo</Badge>
															)}
														</div>
														<Badge bg="primary" pill>
															{tipo.valores?.length || 0} valores
														</Badge>
													</div>
													{tipo.valores && tipo.valores.length > 0 && (
														<div className="mt-2">
															{tipo.valores.slice(0, 5).map((valor) => (
																<Badge
																	key={valor.id}
																	bg={valor.activo ? "light" : "secondary"}
																	text={valor.activo ? "dark" : "light"}
																	className="me-1 mb-1"
																>
																	{valor.nombre}
																</Badge>
															))}
															{tipo.valores.length > 5 && (
																<Badge bg="light" text="muted" className="me-1 mb-1">
																	+{tipo.valores.length - 5} más
																</Badge>
															)}
														</div>
													)}
												</Card.Body>
											</Card>
										))}
									</div>
								) : (
									<div className="text-muted">
										<i className="fa fa-info-circle me-2"></i>
										Esta categoría no tiene atributos por defecto asignados.
									</div>
								)}
							</div>
						</Col>
						<Col sm={12} md={6}>
							<div className="text-center mt-4">
								<h5>Imagen de la categoría</h5>
								<div className="mt-3 image-container">
									<img
										src={imageUrl}
										alt={categoria.nombre}
										className="img-fluid rounded"
										style={{ maxHeight: "300px", maxWidth: "100%" }}
										onError={(e) => { e.target.onerror = null; e.target.src = defaultImage }}
									/>
								</div>
							</div>
						</Col>
					</Row>
				)}
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-secondary" onClick={handleClose} className="w-100">
					Cerrar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default VerCategoria